export const conversas = (state) => state.conversas
export const selectedConversa = (state) => state.selectedConversa
export const mensagens = (state) => state.mensagens
// Default true: enquanto a carga inicial não definiu o has_more, assumimos
// que há mais (evita esconder o scroll-histórico por leitura precoce).
export const mensagensHasMore = (state) => state.mensagensHasMore !== false
export const loadingConversas = (state) => state.loadingConversas
export const loadingMensagens = (state) => state.loadingMensagens
export const uploadProgress = (state) => state.uploadProgress
export const replyTo = (state) => state.replyTo
export const noteMode = (state) => state.noteMode
export const editingMessage = (state) => state.editingMessage
export const respostasRapidas = (state) => state.respostasRapidas
export const filtroStatus = (state) => state.filtroStatus
export const filtroProfissional = (state) => state.filtroProfissional
export const linkedTaskByMessageId = (state) => state.linkedTaskByMessageId
export const tarefasVinculadasConversa = (state) => state.linkedTaskList
export const notasConversa = (state) => state.notasConversa
export const loadingNotas = (state) => state.loadingNotas
export const conversasPage = (state) => state.conversasPage
export const conversasHasMore = (state) => state.conversasHasMore
export const loadingMoreConversas = (state) => state.loadingMoreConversas
